import React, { useState, useEffect } from 'react';
import { Badge } from 'antd';
import orderService from '../../services/orderService';

const OrderCountBadge: React.FC = () => {
  const [count, setCount] = useState<number>(0);

  useEffect(() => {
    const fetchCount = async () => {
      try {
        setCount(0);
      } catch (error) {
        console.error('Error fetching processing orders count:', error);
      }
    };

    fetchCount();

    // Poll for updates every minute
    const interval = setInterval(fetchCount, 60000);

    return () => clearInterval(interval);
  }, []);

  return count > 0 ? (
    <Badge count={count} size='default' style={{ backgroundColor: '#faad14' }} />
  ) : null;
};

export default OrderCountBadge;
